import { Storage } from './storage'

const PREFIX = 'LVC_CACHE_'

export function storeInCache(key: string, data: any, expirationMS?: number): void {
  internalStoreInCache(key, data, expirationMS, false)
}

export function storeInSessionCache(key: string, data: any, expirationMS?: number): void {
  internalStoreInCache(key, data, expirationMS, true)
}

function internalStoreInCache(
  key: string,
  data: any,
  expirationMS: number | undefined,
  useSession: boolean
): void {
  let date = Date.now()
  let expiration = expirationMS || 1000 * 60 * 30
  let value = {
    date: date + expiration,
    data: data,
  }

  let storage = new Storage({
    useSession: useSession,
  })

  storage.setItem(`${PREFIX}${key}`, value)
}

export function getFromSessionCache(key: string, deleteAfterRead?: boolean): any {
  return internalGetFromCache(key, deleteAfterRead, true)
}

export function getFromCache(key: string, deleteAfterRead?: boolean): any {
  return internalGetFromCache(key, deleteAfterRead, false)
}

function internalGetFromCache(
  key: string,
  deleteAfterRead: boolean | undefined,
  useSession: boolean
): any {
  let storage = new Storage({
    useSession: useSession,
  })

  let value = storage.getItem(`${PREFIX}${key}`)

  if (value) {
    let date = value.date
    let data = value.data

    let now = Date.now()
    let diff = now - date

    if (diff < 0) {
      if (deleteAfterRead) {
        storage.removeItem(`${PREFIX}${key}`)
      }
      return data
    } else {
      storage.removeItem(`${PREFIX}${key}`)
      return null
    }
  } else {
    return null
  }
}
